import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map, Observable, switchMap} from "rxjs";
import {
  AttachProductCard,
  CreateProductCard,
  ProductCard,
} from "../types/product-card.types";
import {baseUrl} from "../../../../constants/base-url";
import {RecordsDataRequestQueryParams} from "../../../../types/records-table.types";
import {productCardResourceType} from "../configs/product-card-configs";

@Injectable({
  providedIn: 'root'
})
export class ProductCardModalApiService {
  private http: HttpClient = inject(HttpClient);

  private url: string = `${baseUrl}/${productCardResourceType.path}`;

  public getProductCards(requestQueryParams: RecordsDataRequestQueryParams): Observable<Array<ProductCard>> {
    return this.http.get<Array<ProductCard>>(`${this.url}/`, {
      params: requestQueryParams
    });
  }

  public createProductCard({ article, articleId, title, marketplace }: CreateProductCard): Observable<ProductCard> {
    const params = {
      title: title,
      article: article,
    };

    return this.http.post<ProductCard>(`${this.url}`, params).pipe(
      switchMap((createdCard: ProductCard) => {
        return this.attachProductCard({
          marketplace: marketplace,
          queryParams: {
            id: createdCard.id,
            articleId: articleId
          }
        }).pipe(
          map(() => createdCard)
        );
      })
    );
  }

  public attachProductCard({ marketplace, queryParams }: AttachProductCard): Observable<void> {
    return this.http.post<void>(`${this.url}/attach/${marketplace}`, {}, { params: queryParams }).pipe(
      switchMap(() => {
        return this.scheduleProductCard();
      })
    );
  }

  private scheduleProductCard(): Observable<void> {
    return this.http.post<void>(`${this.url}/schedule/feedbacks`, {});
  }
}
